// Styles for ContentTabs go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledContentTabs = styled.div`
  .tabMenu_content {
    .tab-wrapper {
      margin: 0;
      padding: 0;
      @media screen and (min-width: ${toRem(768)}) {
        width: 40%;
      }
    }
    .m-switcher-tab-list {
      .m-switcher-tab-list-item {
        box-shadow: none !important;
        a {
          span {
            color: black;
          }
        }
      }
    }
  }
`;
